"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.internalSelectionMenuBodyInjectionKey = exports.internalSelectionMenuInjectionKey = void 0;
const create_injection_key_1 = require("../../../_utils/vue/create-injection-key");
exports.internalSelectionMenuInjectionKey = (0, create_injection_key_1.createInjectionKey)('n-internal-select-menu');
exports.internalSelectionMenuBodyInjectionKey = (0, create_injection_key_1.createInjectionKey)('n-internal-select-menu-body');
